export default __webpack_public_path__ + "static/media/pokeballHolo.f18a82bd.svg";